import { useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router';

// This is now a shim between react-router v6 and v5.  Once we update to
// v6, we can delete this.  The original implementation has moved to
// useActivityFilters.  The main purpose of this is to trick a component
// to render when the search params are changed programatically.

export type ParamKeyValuePair = [string, string];

export type SetURLSearchParams = (nextInit?: URLSearchParams) => void;

export function useSearchParams(): [URLSearchParams, SetURLSearchParams] {
  const $history = useHistory();
  const [, rerender] = useState(0);

  const urlSearchParams = useMemo(
    () => new URLSearchParams($history.location.search),
    [$history.location.search],
  );

  const setSearchParams = useCallback(
    (nextInit?: URLSearchParams) => {
      $history.push({
        pathname: $history.location.pathname,
        search: nextInit?.toString(),
      });
      // And here be dragons.  Remember that react rerenders components only when the
      // props change, or the state changes.  So since history.location.* is not part of the
      // state or props, we will force a rerender at this time.  Router v6 handles this for us
      // but we can trick this here.
      rerender(new Date().getTime());
    },
    [$history],
  );

  return [urlSearchParams, setSearchParams];
}
